module.exports = __webpack_public_path__ + "img/mg.3d9b8c12.svg";